import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Proposal Domains',
      type: 'table',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'save.proposal.domain.row',
            },
          },
          {
            '{}': {
              alias: 'delete.proposal.domain.row',
            },
          },
        ],
      },
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'rows',
                },
              },
              subqueries: {
                rows: {
                  filter: {
                    '=': [
                      {
                        '@': 'linkedProposalId',
                      },
                      {
                        '``': {
                          '@$': 'proposalId',
                        },
                      },
                    ],
                  },
                  target: 'ent:!proposal_domain:!entry',
                  selection: {
                    '@.': '!id',
                  },
                  subqueries: {
                    linkedProposalId: {
                      ref: {
                        attr: 'attr:ent#!proposal_domain#!entry:!proposal',
                      },
                      target: 'ent:!proposals:!proposal',
                      selection: {
                        '@.': '!id',
                      },
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                '=': [
                  {
                    '@': 'linkedProposalId',
                  },
                  {
                    '``': {
                      '@$': 'proposalId',
                    },
                  },
                ],
              },
              target: 'ent:!proposal_domain:!entry',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      id: {
                        '{}': {
                          value: {
                            '@.': '!id',
                          },
                        },
                      },
                      domainId: {
                        '{}': {
                          value: {
                            '@': 'domainId',
                          },
                        },
                      },
                      domainName: {
                        '{}': {
                          value: {
                            '@': 'domainName',
                          },
                        },
                      },
                    },
                  },
                  onEdit: {
                    '{}': {
                      action: {
                        '{}': {
                          payload: {
                            '{}': {
                              widget: {
                                '{}': {
                                  alias: 'edit.proposal.domain.row',
                                },
                              },
                              variables: {
                                '{}': {
                                  proposalId: {
                                    '@$': 'proposalId',
                                  },
                                  proposalDomainId: {
                                    '@.': '!id',
                                  },
                                },
                              },
                            },
                          },
                          operation: 'ui.modal',
                        },
                      },
                    },
                  },
                  onDelete: {
                    '{}': {
                      action: {
                        '{}': {
                          alias: 'delete.proposal.domain.row',
                        },
                      },
                      confirm: {
                        '{}': {
                          title: 'Delete proposal domain',
                          message: 'Are you sure?',
                        },
                      },
                      variables: {
                        '{}': {
                          proposalDomainId: {
                            '@.': '!id',
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                domainId: {
                  ref: {
                    attr: 'attr:ent#!proposal_domain#!entry:!domain',
                  },
                  target: 'ent:!domains:!domain',
                  selection: {
                    '@.': '!id',
                  },
                },
                domainName: {
                  ref: {
                    attr: 'attr:ent#!proposal_domain#!entry:!domain',
                  },
                  target: 'ent:!domains:!domain',
                  selection: {
                    '@.': '!name',
                  },
                },
                linkedProposalId: {
                  ref: {
                    attr: 'attr:ent#!proposal_domain#!entry:!proposal',
                  },
                  target: 'ent:!proposals:!proposal',
                  selection: {
                    '@.': '!id',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'domainName',
                  direct: {
                    '{}': {
                      name: 'Domain',
                      type: 'TEXT',
                    },
                  },
                },
              },
            ],
          },
          onCreate: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias: 'edit.proposal.domain.row',
                        },
                      },
                      variables: {
                        '{}': {
                          proposalId: {
                            '@$': 'proposalId',
                          },
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        },
      },
    },
  },
  variables: {
    proposalId: '?1',
  },
}
